import _ from 'lodash';

export function filterData(data = [], term = '', propertyKeys = []) {
  const matcher = '*';

  const trimmedTerm = term.trim();
  const lastCharIndex = term.length > 0 ? term.length - 1 : 0;

  const isPrefixMatch = trimmedTerm[lastCharIndex] === matcher;
  const isPostfixMatch = trimmedTerm[0] === matcher;
  const isPartialMatch = isPrefixMatch && isPostfixMatch;

  const sanitizedTerm = trimmedTerm.replace(/\*/g, '').toLowerCase();

  if (sanitizedTerm === '') {
    return data;
  } else if (isPartialMatch) {
    return filterObjects(data, sanitizedTerm, propertyKeys, partialMatchPredicate);
  } else if (isPrefixMatch) {
    return filterObjects(data, sanitizedTerm, propertyKeys, prefixMatchPredicate);
  } else if (isPostfixMatch) {
    return filterObjects(data, sanitizedTerm, propertyKeys, postfixMatchPredicate);
  } else {
    return filterObjects(data, sanitizedTerm, propertyKeys, exactMatchPredicate);
  }
}

function filterObjects(
  objects = [],
  term = '',
  propertyKeys = [],
  predicate = (value, term) => false,
) {
  return objects.filter((obj) => {
    for (const key of propertyKeys) {
      const propertyKeyValue = _.get(obj, key);

      if (!propertyKeyValue) {
        console.warn(`Value not found for ${key} in filterObjects`);
      }

      const valueIsArray = Array.isArray(propertyKeyValue);

      if (valueIsArray) {
        for (const value of propertyKeyValue) {
          if (checkPredicate(value, term, predicate)) {
            return true;
          }
        }
      } else {
        if (checkPredicate(propertyKeyValue, term, predicate)) {
          return true;
        }
      }
    }

    return false;
  });
}

function checkPredicate(value = '', term, predicate) {
  value = value.toLowerCase();
  return predicate(value, term);
}

function partialMatchPredicate(value = '', term = '') {
  return value.indexOf(term) >= 0;
}

function prefixMatchPredicate(value = '', term = '') {
  return value.indexOf(term) === 0;
}

function postfixMatchPredicate(value = '', term = '') {
  return value.indexOf(term) > 0;
}

function exactMatchPredicate(value = '', term = '') {
  const split = value.split(' ');
  return split.includes(term);
}
